import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Heading } from '@/components/ui/typography';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

function Summary({ onUpdate, data }) {
  const [summary, setSummary] = useState(data || '');

  useEffect(() => {
    onUpdate(summary);
  }, [summary]);

  const handleChange = (e) => {
    setSummary(e.target.value);
  };

  return (
    <Card className="mb-6 bg-white">
      <CardContent className="p-4">
        <Heading level="h2" className="text-base font-semibold mb-3">
          Summary
          <span className="text-destructive ml-1">*</span>
        </Heading>
        <Textarea
          id="summary"
          placeholder="Write Summary here....."
          value={summary}
          onChange={handleChange}
          className={cn("w-full min-h-[106px]")}
        />
      </CardContent>
    </Card>
  );
}

export default Summary;